import { writable } from 'svelte/store';

const hakusanat = writable([]);

export default hakusanat;
